import { render } from "./UnshareIcon.vue?vue&type=template&id=b2f8ef1e"
import script from "./UnshareIcon.vue?vue&type=script&lang=js"
export * from "./UnshareIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__